var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDownloadable)?_c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeSrc},on:{"load":_vm.onIFrameLoaded}}):_c('div',{attrs:{"id":"emptycontent"}},[_c('div',{staticClass:"icon-error"}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.t('files_pdfviewer', 'To view a shared PDF file, the download needs to be allowed for this file share')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }